import axios from "axios";
import { ROOT_URL } from "../../api/ApiConfig";

// Kept separate from the tenant `auth_token` so a platform admin session never leaks into the agent app.
const SESSION_KEY = "trustchat_platform_admin_session";
const LOGIN_URL = `${ROOT_URL}/platform-admin/login`;

export function getPlatformSession() {
  const raw = localStorage.getItem(SESSION_KEY) || sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function saveSession(session, rememberMe) {
  (rememberMe ? localStorage : sessionStorage).setItem(SESSION_KEY, JSON.stringify(session));
  (rememberMe ? sessionStorage : localStorage).removeItem(SESSION_KEY);
}

/** `{ ok, staff }` or `{ ok: false, field, message }`. */
export async function signInPlatformAdmin({ email, password, rememberMe }) {
  let result;
  try {
    const response = await axios.post(
      LOGIN_URL,
      { email: email.trim(), password },
      { headers: { "Content-Type": "application/json" }, withCredentials: false }
    );
    result = response.data;
  } catch (error) {
    result = error?.response?.data || { success: false, message: error?.message || "Unable to sign in" };
  }

  if (!result?.success || !result?.token) {
    const message = result?.message || "Unable to sign in. Please try again.";
    const lower = message.toLowerCase();
    const field = lower.includes("password")
      ? "password"
      : lower.includes("email") || lower.includes("user") || lower.includes("account")
        ? "email"
        : "password";
    return { ok: false, field, message };
  }

  const data = result.data || {};
  const staff = {
    id: data._id,
    name: data.full_name || "Platform Admin",
    email: data.email || email.trim(),
    role: "Platform Admin",
  };
  saveSession({ staff, token: result.token, signedInAt: Date.now() }, rememberMe);
  return { ok: true, staff };
}

export function signOutPlatformAdmin() {
  localStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(SESSION_KEY);
}
